import './ChapterNavigation.css';

const ChapterNavigation = ({ 
  onNavigate, 
  currentChapter, 
  chapters, 
  showBottom = false 
}) => {
  if (!currentChapter || !chapters.length) {
    return null;
  }

  const currentIndex = chapters.findIndex(ch => ch.id === currentChapter.id);
  const prevChapter = currentIndex > 0 ? chapters[currentIndex - 1] : chapters[chapters.length - 1];
  const nextChapter = currentIndex < chapters.length - 1 ? chapters[currentIndex + 1] : chapters[0];

  const isFirst = currentIndex === 0;
  const isLast = currentIndex === chapters.length - 1;

  return (
    <div className={`chapter-navigation ${showBottom ? 'bottom' : 'top'}`}>
      <button
        onClick={() => onNavigate('prev')}
        className="nav-button prev-button"
        title={`Previous: ${prevChapter.book} ${prevChapter.chapter}`}
      >
        <span className="nav-icon">‹</span>
        <span className="nav-text">
          <span className="nav-label">Previous</span>
          <span className="nav-chapter">{prevChapter.book} {prevChapter.chapter}</span>
        </span>
      </button>

      <div className="current-chapter-info">
        <span className="chapter-number">{currentIndex + 1}</span>
        <span className="chapter-total">of {chapters.length}</span>
        {isFirst && <span className="position-label">(First chapter)</span>}
        {isLast && <span className="position-label">(Last chapter)</span>}
      </div>

      <button
        onClick={() => onNavigate('next')}
        className="nav-button next-button"
        title={`Next: ${nextChapter.book} ${nextChapter.chapter}`}
      >
        <span className="nav-text">
          <span className="nav-label">Next</span>
          <span className="nav-chapter">{nextChapter.book} {nextChapter.chapter}</span>
        </span>
        <span className="nav-icon">›</span>
      </button>
    </div>
  );
};

export default ChapterNavigation;
